import { useEffect, useState } from "react";
import { Tag, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useEvent } from "@/context/AppContext";
import { api, toastErr } from "@/lib/api";

export function LabelChips({ labels = [], testid = "label-chips", small }) {
  if (!labels.length) return null;
  return (
    <div className="flex flex-wrap gap-1" data-testid={testid}>
      {labels.map((l) => (
        <span key={l.id} className={`rounded-full border px-1.5 ${small ? "text-[9px]" : "text-[10px] py-0.5"} font-bold`} style={{ borderColor: `${l.color}66`, color: l.color, background: `${l.color}1A` }}
          data-testid={`${testid}-${l.name}`}>{l.name}</span>
      ))}
    </div>
  );
}

export function useGlobalLabels() {
  const [all, setAll] = useState([]);
  const load = () => api.get("/labels").then((r) => setAll(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEvent("LABELS_UPDATED", load);
  return all;
}

export function LabelsButton({ fanId, labels = [], onChange }) {
  const all = useGlobalLabels();
  const [busy, setBusy] = useState(null);
  const on = new Set(labels.map((l) => l.id));
  const toggle = async (l) => {
    setBusy(l.id);
    try {
      const { data } = on.has(l.id) ? await api.delete(`/fans/${fanId}/labels/${l.id}`) : await api.post(`/fans/${fanId}/labels/${l.id}`);
      onChange?.(data);
    } catch (e) { toastErr(e); } finally { setBusy(null); }
  };
  return (
    <Popover>
      <PopoverTrigger className="flex items-center gap-1 rounded-md px-1.5 py-1 text-xs text-slate-400 hover:text-white hover:bg-white/5" title="Etichette" data-testid="chat-labels-btn">
        <Tag className="h-4 w-4" /><span className="hidden lg:inline">Etichette</span>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-60 bg-[#12141D] border-[#232738] p-2" data-testid="chat-labels-popover">
        <div className="text-[10px] font-bold uppercase tracking-wider text-slate-500 px-1 mb-1.5">Etichette cliente</div>
        {!all.length ? <div className="text-xs text-slate-500 px-1 py-2" data-testid="labels-empty">Nessuna etichetta: le crea un Titolare in Impostazioni → Etichette.</div> : (
          <div className="max-h-64 overflow-y-auto space-y-0.5">
            {all.map((l) => (
              <button key={l.id} onClick={() => toggle(l)} disabled={busy === l.id} data-testid={`label-toggle-${l.name}`} aria-pressed={on.has(l.id)}
                className="w-full flex items-center gap-2 rounded px-2 py-1.5 text-xs hover:bg-white/5 transition-colors">
                <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ background: l.color }} />
                <span className="flex-1 text-left truncate">{l.name}</span>
                {on.has(l.id) && <Check className="h-3.5 w-3.5 text-violet-300" />}
              </button>
            ))}
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
